import PropTypes from 'prop-types';
import React from 'react';

import { formatNumber } from '../utils';

const CheckOption = ({ label, count, on, onClick }) => (
  <button type="button" className={`ab-opt ${on ? 'ab-opt--on' : ''}`} onClick={onClick} aria-pressed={on}>
    <span className="ab-opt__main">
      <span className={`ab-check ${on ? 'ab-check--on' : ''}`}>
        {on && (
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--sl-fg-white)' }}
            strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 12.5l5.5 5.5L20 6.5" /></svg>
        )}
      </span>
      <span className="ab-opt__label">{label}</span>
    </span>
    {count != null && <span className="ab-opt__count">{formatNumber(count)}</span>}
  </button>
);
CheckOption.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  on: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CheckOption;
